<template>
    <div>
        <message-dialog v-if="successMessage" @input="successMessage = false">
            <template v-slot:title>
                Success
            </template>
            Your file was uploaded successfully
        </message-dialog>
        <message-dialog v-if="errorMessage" @input="errorMessage = false">
            <template v-slot:title>
                Error
            </template>
            There was an error uploading your file
        </message-dialog>
        <div class="d-flex flex-nowrap align-center justify-center list-complete-item mr-0">
            <v-file-input @change="onReportUploaded" :label="label" :placeholder="placeholder" :value="selectedFile" :dense="dense" :disabled="disabled || readonly" :clearable="false" />
            <v-btn v-if="!disableDelete" text small fab @click="onReportUploaded(null)"><v-icon>mdi-close</v-icon></v-btn>
        </div>
        <v-progress-circular v-if="isLoading" :size="40" :width="7" indeterminate color="tertiary" />
    </div>
</template>

<script>
    import axios from 'axios'

    export default {
        props: [
            'value',
            'label',
            'readonly',
            'dense',
            'disabled',
            'disableDelete'
        ],

        components: {
            messageDialog: () => import('../components/MessageDialog')
        },

        data() {
            return {
                isLoading: false,
                placeholder: "",
                successMessage: false,
                errorMessage: false,
                selectedFile: null
            }
        },

        methods: {
            async onReportUploaded(file) {
                if (file === null) {
                    this.$emit('input', null);
                    this.placeholder = "";
                    this.selectedFile = null;
                    return;
                }
                var formData = new FormData();
                formData.append("file", file);
                this.isLoading = true;
                var name = file.name.split('.')[0];
                var extension = "." + file.name.split('.')[1];
                formData.append("name", name);
                formData.append("extension", extension);
                var fileResponse = await axios.post('/api/Files/', formData);
                var fileData = fileResponse.data;
                this.$emit('input', fileData.id);

                this.successMessage = true;
                this.isLoading = false;
            },
            async previouslyUploadedFile() {
                if (this.value !== null && typeof this.value !== "undefined") {
                    var fileResponse = await axios.get('/api/Files/' + this.value);
                    this.placeholder = fileResponse.data.name + fileResponse.data.extension;
                    this.selectedFile = new File([], this.placeholder, {
                        type: "text/plain",
                    })
                    return;
                }
                this.placeholder = "";
            }
        },
        watch: {
            value: {
                immediate: true,
                handler() {
                    this.previouslyUploadedFile();
                }
            }
        }
    };
</script>
<style scoped>
    .file-image {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }
</style>
